import type React from "react";

import { getRouteApi } from "@tanstack/react-router";

import { useBook } from "../../../app/books/hook";
import { CoverImage } from "./cover";
import { BookDetails } from "./details";
import { BookLinks } from "./links";
import { MainInfo } from "./mainInfo";

export const BookPage: React.FC = () => {
  const routeApi = getRouteApi("/books/$bookId");
  const params = routeApi.useParams();

  const book = useBook(params.bookId);

  if (book === null) {
    return;
  }

  return (
    <div className="mx-auto px-4 py-8">
      <div className="mb-8 grid grid-cols-1 items-stretch gap-8 lg:grid-cols-4">
        <div className="order-2 lg:order-1 lg:col-span-1">
          <div className="dui-card bg-base-200 flex h-full items-center justify-center shadow-xl">
            <CoverImage book={book} />
          </div>
        </div>

        <div className="order-1 lg:order-2 lg:col-span-3">
          <div className="dui-card bg-base-200 h-full shadow-xl">
            <MainInfo book={book} />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <BookDetails book={book} />

        <BookLinks book={book} />
      </div>
    </div>
  );
};
